<div class="contact-background">
  <img src="assets/wavecontact.png" alt="Décor vague" class="decor-wave" />
</div>

<div class="contact-content">
  <section class="contact-page">
    <div class="contact-container">
      <h2 class="contact-heading">🛡️ Une question ? Un besoin ?</h2>
      <p class="contact-text">
        Vous utilisez l’application Qaryos ou souhaitez en savoir plus ? Un souci technique ou une
        demande spécifique ? Notre équipe est à votre écoute.
      </p>
      <p class="contact-text">
        📩 Écrivez-nous via le formulaire ci-dessous ou contactez-nous directement à
        <strong>contact&#64;Qaryos.fr</strong>
      </p>
      <p class="contact-text">
        📌 <strong>Collaboration & Partenariat</strong> : Vous êtes un hôtel, une entreprise ou un
        établissement disposant de rondiers, de veilleurs de nuit, d’agents multi-sites ou de
        personnels itinérants ?
      </p>
      <p class="contact-text">
        ⏱️ Nous nous engageons à vous répondre sous 24 à 48h (hors week-end et jours fériés).
      </p>

      <h3 class="contact-thanks">Merci pour votre confiance,<br />L’équipe Qaryos</h3>

      <!-- MESSAGE DE SUCCÈS -->
      <div *ngIf="successMessage" class="form-success">
        {{ successMessage }}
      </div>

      <form class="contact-form" (submit)="onSubmit($event)">
        <div class="row">
          <div class="form-group">
            <label for="name">Nom*</label>
            <input type="text" id="name" name="name" required [(ngModel)]="form.name" />
          </div>
          <div class="form-group">
            <label for="email">E-mail*</label>
            <input type="email" id="email" name="email" required [(ngModel)]="form.email" />
          </div>
        </div>

        <div class="row">
          <div class="form-group company-group">
            <label for="company">Entreprise*</label>
            <input type="text" id="company" name="company" required [(ngModel)]="form.company" />
          </div>
          <div class="form-group how-group">
            <label for="how">Comment nous avez-vous connu&nbsp;?</label>
            <select id="how" name="how" [(ngModel)]="form.how">
              <option value="">Sélectionnez...</option>
              <option value="Recherche Google">Recherche Google</option>
              <option value="Recommandation">Recommandation</option>
              <option value="Réseaux sociaux">Réseaux sociaux</option>
              <option value="Salon/événement">Salon/événement</option>
              <option value="Autre">Autre</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="subject">Objet*</label>
          <input type="text" id="subject" name="subject" required [(ngModel)]="form.subject" />
        </div>

        <div class="form-group">
          <label for="message">Message*</label>
          <textarea
            id="message"
            name="message"
            rows="5"
            maxlength="3000"
            required
            [(ngModel)]="form.message"
          ></textarea>
          <div class="char-count">{{ charCount }}/{{ maxLen }}</div>
        </div>

        <button type="submit" class="contact-submit" [disabled]="loading">
          {{ loading ? 'Envoi...' : 'Envoyer' }}
        </button>
        <p class="required-note">* Champs obligatoire</p>

        <div *ngIf="errorMessage" class="form-success" style="background: #7e1b1b">
          {{ errorMessage }}
        </div>
        <div *ngIf="successMessage" class="form-success">{{ successMessage }}</div>
      </form>
    </div>
  </section>
</div>
